// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Bio-module--avatar--v_AB0","footer":"Bio-module--footer--CtWDH"};